import { Unreachable } from '@lemon8/web-app-shared/util';

interface CommonSchemaBuildingProps {
  pageType: string;

  // 拉活渠道细分 TODO type
  campaign?: string;
}

interface DetailSchemaBuildingProps extends CommonSchemaBuildingProps {
  groupId: string;
  authorId?: string;
}

interface ArticleSchemaBuildingProps extends DetailSchemaBuildingProps {
  pageType: 'article';
}

const isArticleSchemaBuildingProps = (input: CommonSchemaBuildingProps): input is ArticleSchemaBuildingProps =>
  input.pageType === 'article';

interface VideoSchemaBuildingProps extends DetailSchemaBuildingProps {
  pageType: 'video';
}

const isVideoSchemaBuildingProps = (input: CommonSchemaBuildingProps): input is VideoSchemaBuildingProps =>
  input.pageType === 'video';

export interface UserSchemaBuildingProps extends CommonSchemaBuildingProps {
  pageType: 'user';
  userId: string;
}

const isUserSchemaBuildingProps = (input: CommonSchemaBuildingProps): input is UserSchemaBuildingProps =>
  input.pageType === 'user';

interface CategorySchemaBuildingProps extends CommonSchemaBuildingProps {
  pageType: 'feed';
  categoryId: number;
}

const isCategorySchemaBuildingProps = (input: CommonSchemaBuildingProps): input is CategorySchemaBuildingProps =>
  input.pageType === 'feed';

export interface HashtagSchemaBuildingProps extends CommonSchemaBuildingProps {
  pageType: 'hashtag';
  hashtagId: string;
}

const isHashtagSchemaBuildingProps = (input: CommonSchemaBuildingProps): input is HashtagSchemaBuildingProps =>
  input.pageType === 'hashtag';

export interface POISchemaBuildingProps extends CommonSchemaBuildingProps {
  pageType: 'poi';
  poiId: string;
}

const isPOISchemaBuildingProps = (input: CommonSchemaBuildingProps): input is POISchemaBuildingProps =>
  input.pageType === 'poi';

export interface SearchSchemaBuildingProps extends CommonSchemaBuildingProps {
  pageType: 'search';
  query: string;
}

const isSearchSchemaBuildingProps = (input: CommonSchemaBuildingProps): input is SearchSchemaBuildingProps =>
  input.pageType === 'search';

export type DeepLinkBuildingProps =
  | ArticleSchemaBuildingProps
  | VideoSchemaBuildingProps
  | UserSchemaBuildingProps
  | CategorySchemaBuildingProps
  | HashtagSchemaBuildingProps
  | POISchemaBuildingProps
  | SearchSchemaBuildingProps;

export const buildSchema = (props: DeepLinkBuildingProps & { pid: string }): string => {
  let protocol = 'snssdk2657';
  let host = 'unknown';
  let params: URLSearchParams;

  if (isArticleSchemaBuildingProps(props)) {
    host = 'article_detail_page';
    params = new URLSearchParams({
      group_id: props.groupId,
    });
    if (props.authorId) {
      params.set('media_id', props.authorId);
    }
  } else if (isVideoSchemaBuildingProps(props)) {
    host = 'video_detail';
    params = new URLSearchParams({
      group_id: props.groupId,
    });
    if (props.authorId) {
      params.set('media_id', props.authorId);
    }
  } else if (isUserSchemaBuildingProps(props)) {
    host = 'user_profile';
    params = new URLSearchParams({
      user_id: props.userId,
    });
  } else if (isCategorySchemaBuildingProps(props)) {
    host = 'main';
    params = new URLSearchParams({
      tab: 'home',
      channel_id: String(props.categoryId),
    });
  } else if (isHashtagSchemaBuildingProps(props)) {
    host = 'hashtag';
    params = new URLSearchParams({
      hashtag_id: props.hashtagId,
    });
  } else if (isPOISchemaBuildingProps(props)) {
    host = 'poi_landing_page';
    params = new URLSearchParams({
      poi_id: props.poiId,
    });
  } else if (isSearchSchemaBuildingProps(props)) {
    host = 'lynxview';
    params = new URLSearchParams({
      channel: 'search_v2',
      bundle: 'result_page/template.js',
      trans_status_bar: '1',
      enter_anim: 'search_alpha',
      exit_anim: 'search_alpha',
      business_type: 'search',
      business_data: JSON.stringify({
        query: props.query,
        tab: 0,
        inputClickType: 'open',
        logExtra: {
          query: props.query,
          search_page_from: 'search_page_general',
          search_from: 'seo_click',
          previous_page_name: 'seo',
        },
      }),
    });
  } else {
    return Unreachable('no match schema handler');
  }

  // append common params
  params.append('pid', props.pid);
  if (props.campaign) {
    params.append('campaign', props.campaign);
  }

  return `${protocol}//${host}?${params.toString()}`;
};
